module.exports = __webpack_public_path__ + "static/media/1013120.a307903e.jpg";